import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* Components */
import { Avatar, Icon } from "../../components"

/* Constants */
import { env } from "../../constants"

/* Helpers */
import { utils } from "../../helpers"

/* REST API */
import { deleteTemplate } from "../../api/Notification"

/* Widgets */
import { toast, confirm } from "../common"
import Preview from "./Preview"

/* Shared */
import { line, notificationIcon, stateOf, typeOf } from "./shared"

moment.locale("ru")
Modal.setAppElement("#root")


/* Widget Details Modal — the card of one template, a panel which slides in from the right.
   It is opened by the reference: this._details.current.open(template), so the page keeps
   nothing about it in its own state */
class DetailsModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            template: null,
            removing: false
        }
    }

    /* Open the card of the template */
    open = template => {
        this.setState({ visible: true, template, removing: false })
    }

    /* Close the card */
    close = () => {
        this.setState({ visible: false, template: null })
    }

    /* Send it — the choice of the recipients happens in a window of its own */
    send = () => {

        const { template } = this.state
        const { onSend } = this.props

        this.close()

        if (onSend) {
            onSend(template)
        }
    }

    /* Copy it into a new draft */
    copy = () => {

        const { template } = this.state
        const { onCopy } = this.props

        this.close()

        if (onCopy) {
            onCopy(template)
        }
    }

    /* Take the template away */
    remove = () => {

        const { template, removing } = this.state
        const { onRemoved } = this.props

        if (removing) {
            return
        }

        confirm({
            title: "Удалить шаблон?",
            text: "Отправленные уведомления останутся у людей — уходит только шаблон",
            confirmText: "Удалить",
            cancelText: "Отмена",
            danger: true
        }).then(confirmed => {

            if (!confirmed) {
                return
            }

            this.setState({ removing: true })

            deleteTemplate(template.id).then(response => {

                this.setState({ removing: false })

                if (response && response.status === 200) {
                    toast.success("Шаблон удалён")
                    this.close()

                    if (onRemoved) {
                        onRemoved()
                    }
                }
                else {
                    toast.error("Не удалось удалить шаблон")
                }
            })
        })
    }

    /* The head of the card */
    _head = () => {

        /* Fields */
        const { template } = this.state

        const type = typeOf(template.type)
        const state = stateOf(template.sent)
        const image = template.image ? `${env.mediapoint}notifications/${template.image}` : null

        return (
            <div className="nt-details-head">

                <div className="nt-details-head-top">

                    <Avatar className="nt-details-avatar" src={image} alt={template.title}>
                        {notificationIcon()}
                    </Avatar>

                    <div className="nt-details-title">

                        <div className="nt-details-name">{utils.check(template.title, "Без заголовка")}</div>

                        <div className="nt-details-subtitle">
                            <span>{type.text}</span>
                            <span>Создан {moment(template.createdAt).format("DD.MM.YYYY HH:mm")}</span>
                        </div>

                        <div className="nt-details-tags">
                            <div className={`nt-tag ${state.accent}`}>{state.text}</div>
                            {template.image && <div className="nt-tag grey">С фото</div>}
                            {template.button && <div className="nt-tag grey">С кнопкой</div>}
                        </div>

                    </div>

                    <div onClick={this.close} className="nt-details-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>

                </div>

            </div>
        )
    }

    /* The buttons which act on the template */
    _actions = () => {

        /* Fields */
        const { template, removing } = this.state

        return (
            <div className="nt-details-actions">

                {parseInt(template.sent) !== 1 &&
                    <div onClick={this.send} className="nt-details-action primary">
                        <Icon name="right" size={16} />
                        <span>Отправить</span>
                    </div>
                }

                <div onClick={this.copy} className="nt-details-action">
                    <Icon name="edit" size={16} />
                    <span>Копировать</span>
                </div>

                <div onClick={this.remove} className={`nt-details-action danger ${removing ? "disabled" : ""}`}>
                    <Icon name="trash" size={16} />
                    <span>{removing ? "Удаление..." : "Удалить"}</span>
                </div>

            </div>
        )
    }

    /* The body of the card */
    _content = () => {

        /* Fields */
        const { template } = this.state

        const type = typeOf(template.type)
        const state = stateOf(template.sent)

        return (
            <div className="nt-details-body">

                {this._actions()}

                <div className="nt-details-columns">

                    <div className="nt-details-column">

                        <div className="nt-details-section">

                            <div className="nt-details-section-text">Как увидит человек</div>

                            <Preview
                                title={template.title}
                                description={template.description}
                                button={template.button}
                                buttonColor={template.buttonColor}
                                image={template.image}
                            />

                        </div>

                        <div className="nt-details-section">

                            <div className="nt-details-section-text">Уведомление</div>

                            {line("Получатели", type.text)}
                            {line("Статус", state.text, parseInt(template.sent) === 1 ? "accent" : "")}
                            {line("Создан", moment(template.createdAt).format("DD.MM.YYYY HH:mm"))}
                            {line("Изменён", moment(template.updatedAt).format("DD.MM.YYYY HH:mm"))}

                        </div>

                    </div>

                    <div className="nt-details-column">

                        <div className="nt-details-section">

                            <div className="nt-details-section-text">Текст</div>

                            <div className="nt-details-text-title">{utils.check(template.title, "Без заголовка")}</div>
                            <div className="nt-details-text-body">{utils.check(template.description, "—")}</div>

                        </div>

                        <div className="nt-details-section">

                            <div className="nt-details-section-text">Переход</div>

                            {!template.button && !template.screen && <div className="nt-details-empty">Кнопки нет — уведомление просто читают</div>}

                            {line("Кнопка", template.button)}
                            {line("Цвет кнопки", template.buttonColor)}
                            {line("Экран", template.screen)}
                            {line("Параметры", template.params)}

                        </div>

                        <div className="nt-details-section">

                            <div className="nt-details-section-text">Фото</div>

                            {template.image
                                ? <img className="nt-details-image" src={`${env.mediapoint}notifications/${template.image}`} alt="Notification" />
                                : <div className="nt-details-empty">Фото не загружено</div>
                            }

                        </div>

                    </div>

                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, template } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="nt-details-modal"
                overlayClassName="nt-details-overlay"
                closeTimeoutMS={300}
            >
                {template &&
                    <div className="nt-details">
                        {this._head()}
                        {this._content()}
                    </div>
                }
            </Modal>
        )
    }
}

export default DetailsModal
